module.exports = function(app) {

   app.controller("pages.spending.manageSpendingAccount", ["$scope", "session","services", "storage","coremetrics","sessionData","spendingAccountsService","$q","spendingResourceServices","$cookies","$timeout","spaUtil","accountTypes",
        function( $scope, session,services, storage,coremetrics,sessionData,spendingAccountsService,$q,spendingResourceServices,$cookies ,$timeout,spaUtil,accountTypes){
            $scope.accountTypes = accountTypes;
        }])

};